var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9891 23.25L13.1141 15.375C12.4891 15.875 11.7704 16.2708 10.9579 16.5625C10.1454 16.8542 9.28077 17 8.36411 17C6.09327 17 4.1714 16.2135 2.59848 14.6406C1.02556 13.0677 0.239105 11.1458 0.239105 8.875C0.239105 6.60417 1.02556 4.68229 2.59848 3.10938C4.1714 1.53646 6.09327 0.75 8.36411 0.75C10.6349 0.75 12.5568 1.53646 14.1297 3.10938C15.7026 4.68229 16.4891 6.60417 16.4891 8.875C16.4891 9.79167 16.3433 10.6562 16.0516 11.4688C15.7599 12.2812 15.3641 13 14.8641 13.625L22.7391 21.5L20.9891 23.25ZM8.36411 14.5C9.92661 14.5 11.2547 13.9531 12.3485 12.8594C13.4422 11.7656 13.9891 10.4375 13.9891 8.875C13.9891 7.3125 13.4422 5.98438 12.3485 4.89062C11.2547 3.79688 9.92661 3.25 8.36411 3.25C6.80161 3.25 5.47348 3.79688 4.37973 4.89062C3.28598 5.98438 2.73911 7.3125 2.73911 8.875C2.73911 10.4375 3.28598 11.7656 4.37973 12.8594C5.47348 13.9531 6.80161 14.5 8.36411 14.5Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.f115f874f4809ad1cc344c56f050d5e0.svg";
export { ForwardRef as ReactComponent };